<template>
  <form @submit.prevent="$parent.updateSettings">
    <load v-if="loading" />
    <b-card v-else class="shadow">
      <h4 class="mb-0">{{ $t("General") }}</h4>
      <p class="text-muted">{{ $t("Configure general site settings") }}.</p>
      <div class="row mt-3">
        <div class="col-md-8">
          <div class="form-group">
            <label for="app_name">{{ $t("Site name") }}</label>
            <input
              class="form-control"
              id="app_name"
              required
              type="text"
              v-model="$parent.settings.app_name"
            />
            <small class="form-text text-muted"
              >{{ $t("Name of the application") }}.</small
            >
          </div>
          <div role="group" class="form-group">
            <div class="row">
              <form-select
                v-model="$parent.settings.app_estado"
                grid="12"
                label="Estado"
                :required="true"
                :itens="estados"
                @change="getCidades"
              />
            </div>
          </div>
          <div class="form-group">
            <div class="row">
              <form-select
                v-model="$parent.settings.app_cidade"
                grid="12"
                label="Cidade"
                placeholder="Selecione um estado antes"
                :required="true"
                :disabled="$parent.settings.app_estado ? false : true"
                :loading="loadCidades"
                :itens="cidades"
              />
            </div>
          </div>
          <!-- <div class="form-group">
            <label for="app_keywords">{{ $t("Site keywords") }}</label>
            <input
              class="form-control"
              id="app_keywords"
              required
              type="text"
              v-model="$parent.settings.app_keywords"
            />
            <small class="form-text text-muted"
              >{{ $t("Keywords of the application (SEO)") }}.</small
            >
          </div>
          <div class="form-group mb-0">
            <label for="app_description">{{ $t("Site description") }}</label>
            <textarea
              class="form-control"
              id="app_description"
              required
              type="text"
              v-model="$parent.settings.app_description"
            />
            <small class="form-text text-muted"
              >{{ $t("Description of the application (SEO)") }}.</small
            >
          </div> -->
        </div>
      </div>
      <hr class="my-3" />
      <h4 class="mb-0">Autorizar Concessão de Benefícios por Técnicos</h4>
      <div class="row mt-3">
        <div class="col-md-8">
          <div class="form-group">
            <toggle-button
              :sync="true"
              color="#5895FF"
              id="autorizar_concessao"
              v-model="$parent.settings.autorizar_concessao"
            />
            <label class="ml-2" for="autorizar_concessao">{{
              $parent.settings.autorizar_concessao ? "Autorizado" : "Negado"
            }}</label>
            <small class="form-text text-muted"
              >Permitir que os Técnicos possam atualizar o Status da Concessão
              para Concedido sem a necessidade de aguardar a autorização de um
              Gestor ou outro usuário com a devida permissão.</small
            >
          </div>
        </div>
      </div>
      <button
        class="btn btn-success btn-submit m-0"
        data-style="zoom-in"
        type="submit"
      >
        <i class="mdi mdi-content-save" />
        {{ $t("Update") }}
      </button>
    </b-card>
  </form>
</template>

<script>
export default {
  name: "General",
  data() {
    return {
      estados: [],
      cidades: [],
      estado_selecionado: null,
      loading: true,
      loadCidades: false,
    };
  },
  mounted() {
    this.getEstados();
    // this.$root.$on("estadoSelecionado", (data) => {
    // 	this.estado_selecionado = data;
    // 	this.listaCidades();
    // });
  },
  methods: {
    getEstados() {
      axios
        .get(`get-estados`)
        .then((response) => {
          this.estados = response.data;
        })
        .finally(() => {
          this.setSelected(this.$parent.settings.app_estado);
        });
    },
    getCidades() {
      this.loadCidades = true;
      this.$parent.settings.app_cidade = "";
      axios
        .get(`get-cidades/${this.$parent.settings.app_estado}`)
        .then((response) => {
          this.cidades = response.data;
        })
        .finally(() => {
          this.loadCidades = false;
        });
    },
    listaCidades() {
      if (this.estado_selecionado) {
        this.setSelected(this.estado_selecionado);
      }
    },
    setSelected(value) {
      if (value && value != 0) {
        this.loadCidades = true;
        axios
          .get(`get-cidades/${value}`)
          .then((response) => {
            this.cidades = response.data;
          })
          .finally(() => {
            this.loading = false;
            this.loadCidades = false;
          });
      } else {
        this.loading = false;
        this.loadCidades = false;
      }
    },
  },
};
</script>
